import React, { useCallback, useMemo } from 'react';

import { addDays, getTime, subDays } from 'date-fns';

import {
    LEFT_NAVIGATION_ARROW_ID,
    RIGHT_NAVIGATION_ARROW_ID,
} from 'config/testID';

import { EArrowType } from 'components/CustomButtons/ArrowButton';

import EpgTimeBarArrow from '../EpgTimeBarArrow';

type Props = {
    startTime: number;
    handleTimeBarArrowPress: (
        type: EArrowType,
        shouldDateChange: boolean,
    ) => void;
};

function EpgTimeBarArrows({ handleTimeBarArrowPress, startTime }: Props) {
    const today = useMemo(() => {
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);

        return todayDate.getTime();
    }, []);

    const shouldBwdDateChange = useMemo(
        () => startTime !== getTime(subDays(today, 7)),
        [startTime, today],
    );

    const shouldFwdDateChange = useMemo(
        () => startTime !== getTime(addDays(today, 14)),
        [startTime, today],
    );

    const onArrowPress = useCallback(
        (type: EArrowType, shouldDateChange: boolean) => {
            handleTimeBarArrowPress(type, shouldDateChange);
        },
        [handleTimeBarArrowPress],
    );

    return (
        <>
            <EpgTimeBarArrow
                type={EArrowType.BWD}
                onPress={onArrowPress}
                shouldDateChange={shouldBwdDateChange}
                testID={LEFT_NAVIGATION_ARROW_ID}
            />
            <EpgTimeBarArrow
                type={EArrowType.FWD}
                onPress={onArrowPress}
                shouldDateChange={shouldFwdDateChange}
                testID={RIGHT_NAVIGATION_ARROW_ID}
            />
        </>
    );
}

export default EpgTimeBarArrows;
